import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import { GeoContext } from "@context/GeoProvider";

import { useLocalizedSentenceDict } from "@hooks/useSentenceDict";

import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { gaCustomEvent } from "@helpers/browser";

import { ALLink as Link } from "@components/ALComponents";

import { Country } from "@constants/Country";

import { getShopifyStoreByCountry } from "../../../../locale-shopifies";

function BottomMenu({ closeMenu }) {
  const { gePriceDetails } = useContext(GeoContext);
  const dict = useLocalizedSentenceDict();

  const { allContentfulBottomMenu } = useStaticQuery(graphql`
    query BottomMenu {
      allContentfulBottomMenu(sort: { itemOrder: ASC }) {
        nodes {
          id
          node_locale
          title
          link {
            link {
              link
            }
          }
          itemOrder
        }
      }
    }
  `);

  const mobileMenu = allContentfulBottomMenu.nodes.filter(
    (e) => e?.node_locale === gePriceDetails?.Culture
  );

  const onLinkClick = (label) => {
    closeMenu();
    gaCustomEvent("Menu Link", "Click", label);
  };

  const filteredMenu = mobileMenu.filter((item) => {
    const { title } = item;
    const isUS = gePriceDetails?.CountryCode === Country.US;
    return !["meet al luxe"].includes(title.toLowerCase()) || isUS;
  });

  return (
    <div className="sticky bottom-0 w-full grid grid-cols-2 border-t border-dark-grey px-[15px] py-[30px] mt-[15px] typo-body">
      {filteredMenu.map((item) => {
        const { link } = item.link.link;
        const { title } = item;

        if (link === "https://help.analuisa.com") {
          return (
            <a
              href={getShopifyStoreByCountry(gePriceDetails?.CountryCode)?.knowledgeBase}
              className="block w-full mb-[15px]"
              key={`mobile_menu_footer_${item.id}`}
            >
              {dict.get(title)}
            </a>
          );
        }

        return (
          <Link
            className="block w-full mb-[15px]"
            key={`mobile_menu_footer_${item.id}`}
            to={link}
            onClick={() => onLinkClick(title.toUpperCase())}
          >
            {dict.get(title)}
          </Link>
        );
      })}
    </div>
  );
}

BottomMenu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
};

export default memo(
  withALErrorBoundary({
    name: "BottomMenu",
    priority: "P2",
  })(BottomMenu)
);
